<template>
  <div class="base-brf">
    <video class="video" ref="video" muted playsinline/>
    <canvas class="canvas" ref="canvas"/>
  </div>
</template>

<script>
import axios from 'axios'
import initializeBRF from '@/assets/lib/brf'
import pointStyles from './data/pointStyles'
import { CanvasSpace } from 'pts'
export default {
  async mounted () {
    this.video = this.$refs['video']
    this.canvas = this.$refs['canvas']
    this.ctx = this.canvas.getContext('2d')
    await Promise.all([ this.fetchWasm(), this.initCamera() ])
    this.canvas.width = this.video.clientWidth
    this.canvas.height = this.video.clientHeight
    this.initPts()
    this.initBRF()
  },
  beforeDestroy () {
    clearTimeout(this.timer)
    if (this.stream) this.stream.getTracks()[0].stop()
  },
  methods: {
    async fetchWasm () {
      const response = await axios.get(require('@/assets/lib/brf.wasm'), { responseType: 'arraybuffer' })
      if (response.status !== 200) console.error('Error fetching wasm')
      else console.log('Wasm loaded'); this.brfv4WASMBuffer = response.data
    },
    async initCamera () {
      return new Promise(async resolve => {
        this.stream = await navigator.mediaDevices.getUserMedia({ video: true })
          .then(stream => stream)
          .catch(() => this.$router.push({ name: 'unsupported', params: { title: 'Please allow camera access to continue' } }))
        this.video.srcObject = this.stream
        this.video.onloadedmetadata = this.video.play
        this.video.onplay = resolve
      })
    },
    initPts () {
      this.space = new CanvasSpace(this.canvas)
      this.space.autoResize = false
      this.space.background = 'transparent'
      this.form = this.space.getForm()
    },
    initBRF () {
      this.brfv4 = { wasmBinary: this.brfv4WASMBuffer }
      initializeBRF(this.brfv4)
      setTimeout(() => {
        const resolution = new this.brfv4.Rectangle(0, 0, this.canvas.width, this.canvas.height)
        this.brfManager = new this.brfv4.BRFManager()
        this.brfManager.init(resolution, resolution, 'com.tastenkunst.brfv4.js.examples.minimal.webcam')
        this.trackFaces()
        this.$emit('ready')
      }, 2000)
    },
    trackFaces () {
      const timeStart = window.performance.now()
      this.ctx.setTransform(-1.0, 0, 0, 1, this.canvas.width, 0)
      this.form.image(this.video, [[0, 0], [this.canvas.width, this.canvas.height]])
      this.ctx.setTransform(1.0, 0, 0, 1, 0, 0)
      this.brfManager.update(this.ctx.getImageData(0, 0, this.canvas.width, this.canvas.height).data)
      // this.space.clear()
      this.form.fill('rgba(0, 0, 0, 0.7)')
      this.form.rect([[0, 0], [this.canvas.width, this.canvas.height]])
      for (const face of this.brfManager.getFaces()) {
        if (face.state === this.brfv4.BRFState.FACE_TRACKING) {
          for (let k = 0; k < face.vertices.length; k += 2) {
            if (pointStyles[k / 2] === 1) {
              this.form.stroke('white')
              this.form.fill('transparent')
              this.form.point([face.vertices[k], face.vertices[k + 1]], 2, 'circle')
            } else if (pointStyles[k / 2] === 2) {
              this.form.stroke('transparent')
              this.form.fill('white')
              this.form.point([face.vertices[k], face.vertices[k + 1]], 1, 'circle')
            }
          }
        }
      }
      const elapstedMs = window.performance.now() - timeStart
      this.timer = setTimeout(this.trackFaces, 1000 / 30 - elapstedMs)
    }
  }
}
</script>

<style lang="scss" scoped>
.base-brf {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  filter: grayscale(1);
  background: var(--color-black-1);
}
@-moz-document url-prefix() {
  .base-brf {
    filter: none !important;
  }
}
.video,
.canvas {
  position: absolute;
  left: 50%;
  top: 50%;
  width: auto !important;
  height: 100% !important;
  transform: translate(-50%, -50%);
  pointer-events: none;
  display: block;
}
.video {
  visibility: hidden;
}
</style>
